import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { SwiperConfigInterface } from '@app/shared/swiper/swiper.interfaces';
import { SwiperComponent } from '@app/shared/swiper/swiper.component';

export interface Slide {
  title?: string;
  description?: string;
  image: string;
  button?: {
    name: string;
    path: string;
    iconUrl?: string;
  };
}

@Component({
  selector: 'app-full-slider',
  templateUrl: './full-slider.component.html',
  styleUrls: ['./full-slider.component.scss']
})
export class FullSliderComponent implements OnInit, OnChanges {
  @Input() slides: Slide[] = [];
  @ViewChild(SwiperComponent) swiper: SwiperComponent;

  swiperConfig: SwiperConfigInterface = {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 15,
    autoHeight: true,
  };

  currentSlide: Slide;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    const newSlides = changes && changes.slides && changes.slides.currentValue && changes.slides.currentValue;
    if (newSlides && newSlides.length > 0) this.currentSlide = this.slides[0];
  }

  ngOnInit() {
    this.swiper.currentSlideIndexChange
      .subscribe(index => this.currentSlide = this.slides[index]);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/full-slider/full-slider.component.ts